/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Track_Labels_Section_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Track Labels Section" |
*
* @param {Track_Labels_Section_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_labels_section_aria_label = /** @type {((inputs?: Track_Labels_Section_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Labels_Section_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Section des etiquettes de piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abschnitt „Track-Labels“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sezione Etichette Traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Раздел «Названия треков»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sección de etiquetas de pistas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("曲目标签部分")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックラベルセクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक लेबल अनुभाग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seção de Etiquetas de Faixa")
	return /** @type {LocalizedString} */ ("Track Labels Section")
});